import {
  ChatConversationMemberModel,
  ChatConversationModel,
} from '../models/chat.model';

export class ChatHelper {
  public static hasUnread(conversation: ChatConversationModel, currentUserId: Guid): boolean {
    const lastMessage = conversation.lastMessage;

    if (!lastMessage || lastMessage.senderUserId === currentUserId) {
      return false;
    }

    const member = ChatHelper.findActiveMember(conversation, currentUserId);

    if (!member) {
      return false;
    }

    const lastReadDate = member.lastReadDate;

    if (!lastReadDate) {
      return true;
    }

    const lastMessageTime = new Date(lastMessage.sentDate).getTime();
    const lastReadTime = new Date(lastReadDate).getTime();

    return lastMessageTime > lastReadTime;
  }

  public static findActiveMember(
    conversation: ChatConversationModel,
    userId: Guid | undefined
  ): ChatConversationMemberModel | undefined {
    const activeMember = conversation.members.find((member) => member.userId === userId && !member.dateLeft);

    return activeMember;
  }

  public static isActiveMember(conversation: ChatConversationModel, userId: Guid | undefined): boolean {
    const activeMember = ChatHelper.findActiveMember(conversation, userId);

    return !!activeMember;
  }

  public static compareSqlGuids(a: Guid, b: Guid): number {
    const segmentRanges: [number, number][] = [
      [24, 36],
      [19, 23],
      [14, 18],
      [9, 13],
      [0, 8],
    ];

    const left = a.toLowerCase();
    const right = b.toLowerCase();

    for (const [start, end] of segmentRanges) {
      const leftSegment = left.slice(start, end);
      const rightSegment = right.slice(start, end);

      if (leftSegment !== rightSegment) {
        const order = leftSegment < rightSegment ? -1 : 1;

        return order;
      }
    }

    return 0;
  }

  public static formatNameList(names: string[]): string {
    if (names.length <= 1) {
      const singleName = names.join('');

      return singleName;
    }

    const leadingNames = names.slice(0, -1).join(', ');
    const lastName = names.at(-1);

    return `${leadingNames} & ${lastName}`;
  }
}
